import i18next from 'i18next'
import React from 'react'
import { Alphabetized } from '../azNavigation/azNavigationUtils'
import { EmptyLayout } from '../sharedLayout/empty'
import { GenericPageHeader } from '../sharedLayout/pageheader'
import { NavigationSection } from '../sharedLayout/navigationSection'
import { ResearchPerDepartment } from './researchOverviewState'

export const ResearchOverviewHeaderLayout = (props: { breadcrumbs: { title: string; url: string }[] }) => (
  <GenericPageHeader
    kind="researchOverview"
    breadcrumbs={props.breadcrumbs}
    title={i18next.t('misc:scientificResearch_plural')}
    intro={i18next.t('misc:researchOverviewIntro')}
  />
)

export const ResearchOverviewSectionLayout = (props: { researches: Alphabetized<ResearchPerDepartment> }) => (
  <section className="sections sections--pagination sections--research container--m gutter--m">
    {props.researches.length > 0 ? (
      props.researches.map((research) => (
        <NavigationSection kind="research" letter={research.letter} items={research.items} />
      ))
    ) : (
      <EmptyLayout
        hasWrapper={false}
        text={i18next.t('a11y:noEntityFound', {
          entity: i18next.t('misc:research_plural').toLowerCase(),
        })}
      />
    )}
  </section>
)
